<template>
  <div class="question"
       :data-previous-score="previous ? previous.score : 'none'"
       :data-vip="question.indexquestion ? 'true' : 'false'"
       :data-rev="question.scalereverse ? 'true' : 'false'"
       :class="question.invalid ? 'question invalid' : ''">
    <legend class="mb-0  mb-2 d-flex justify-content-between align-items-baseline">
      {{ question.question}}
    </legend>
    <div class="d-flex" v-if="!review">
      <div class="js-webform-webform-scale radio">
        <div class="webform-scale webform-scale-circle webform-scale-medium webform-scale-1-to-5">
          <div class="webform-scale-options">
            <template v-if="!review">
              <div v-for="i in maxScore"
                   class="webform-scale-option"
                   :data-score="i"
                   :class="previousAnswer ? ((previousAnswer === i) ? 'previous' : '') : ''">
<!--                PA-{{previousAnswer? previousAnswer : ''}} &#45;&#45; {{i}}-->
                <input :data-score="i"
                       type="radio"
                       @change="setScore($event,i)"
                       :checked="answer ? answer.score === i : false"
                       :id="'q-'+question.id+'-'+i"
                       :name="'q-'+question.id"
                       :value="i">
                <label class="w-auto" :for="'q-'+question.id+'-'+i">
                  {{getScaleAnchor(i)}}
                </label>
              </div>
            </template>
          </div>
        </div>
      </div>


      <div v-if="review && previous" class="ml-5 js-webform-webform-scale radio previous-reviewed-score">

      </div>
    </div>
  </div>
</template>
<script>
  // import {mapGetters} from 'vuex';//todo use getters
  import store from "../../store/store";
  import {eventPath} from "../../polyfills";

  //logica:
  //computed properties mirroren data uit store
  //watch kijkt naar wijzigingen in computed properties en geeft deze gegevens door naar data
  //data wordt in template uitgelezen en bij wijziging terug naar store gestuurd

  export default {

    computed: {
      previousAnswer() {
        let r = null;
        const previous = store.getters.getPrevious;
        // console.log('question and previous answer',this.question.id,previous[this.question.id]);
        if (previous[this.question.id]) {
          r = previous[this.question.id]
        }
        // console.log('r',r)
        return r
      },

      draftState() {
        return this.store.state.vitaminFormData.draft.answers
      },
      previousState() {
        return this.store.state.vitaminFormData.previous ? this.store.state.vitaminFormData.previous.answers : null
      },
      submittedState() {
        return this.store.state.vitaminFormData.submitted.answers
      },
      submissionState() {
        return this.store.state.vitaminFormData.submitted
      },
    },
    watch: {
      draftState() {
        this.draftState[this.question.id] ? this.answer = this.draftState[this.question.id] : this.answer = {
          comment: '',
          score: 0
        }
      },
      previousState() {
        this.previousState ? this.previous = this.previousState[this.question.id] : null;
      },
      submittedState() {
        this.submitted = this.submittedState[this.question.id];
      },
      submissionState() {
        this.submission = this.submissionState;
      }
    },
    data() {
      return {
        // get previous submission data from state
        originalComment: '',
        showLastReviewed: false,
        maxScore: 7,
        modalShown: false,
        answer: {
          comment: '',
          score: 0
        },

        previous: null,
        submitted: {comment: '', score: 0},
        store: store,
        submission: null,
      }
    },
    methods: {
      getScaleAnchor(score) {
        // console.log(this.question)
        let scores = {};
        switch (this.question.scaletype) {
          case 'oneens_eens':
            scores = {
              1: this.$t('message.oneens_eens_1'),
              2: this.$t('message.oneens_eens_2'),
              3: this.$t('message.oneens_eens_3'),
              4: this.$t('message.oneens_eens_4'),
              5: this.$t('message.oneens_eens_5'),
              6: this.$t('message.oneens_eens_6'),
              7: this.$t('message.oneens_eens_7'),
            };
            return scores[score];
          case 'nooit_altijd':
            scores = {
              1: this.$t('message.nooit_altijd_1'),
              2: this.$t('message.nooit_altijd_2'),
              3: this.$t('message.nooit_altijd_3'),
              4: this.$t('message.nooit_altijd_4'),
              5: this.$t('message.nooit_altijd_5'),
              6: this.$t('message.nooit_altijd_6'),
              7: this.$t('message.nooit_altijd_7'),
            };
            return scores[score];
          case 'ontevreden_tevreden':
            scores = {
              1: this.$t('message.ontevreden_tevreden_1'),
              2: this.$t('message.ontevreden_tevreden_2'),
              3: this.$t('message.ontevreden_tevreden_3'),
              4: this.$t('message.ontevreden_tevreden_4'),
              5: this.$t('message.ontevreden_tevreden_5'),
              6: this.$t('message.ontevreden_tevreden_6'),
              7: this.$t('message.ontevreden_tevreden_7'),
            };
            return scores[score];
          default:
            return score
        }
      },
      //todo reset comment to original (in case of cancel)
      initMenuClick() {
        document.querySelector("body").addEventListener("mouseup", (e) => {
          const el = this.$el.querySelector('.question-comment');

          // console.log('event menuclick');
          // console.log(e);
          if (eventPath(e).includes(el)) {
            // console.log('clicked inside')
          } else {
            // console.log('clicked outside')
            this.modalShown = false
          }
        });
      },
      clearInvalid(e) {
        let el = null;
        if (typeof (e) !== 'undefined') {
          el = e.target.closest('.question');
        } else {
          el = this.$el.querySelector('.webform-scale-options')
        }

        el.classList.remove('invalid');

        const trackerDom = document.querySelectorAll('.progress-step')[this.stepind];
        const stepDom = document.querySelector('#form-step-' + (this.stepind));
        const invalidQuestions = stepDom.querySelectorAll('.question.invalid')
        if (invalidQuestions.length < 1) {
          this.$parent.$parent.step.invalid = false
          trackerDom.classList.remove('invalid')
        }
      },
      getScoreClass(number) {
        return 'score-' + number;
      },
      updateQuestion() { // answer aanpassen in store
        this.store.commit('setAnswer', {
          comment: this.answer.comment,
          score: this.answer.score,
          question: this.question.id
        });
      },
      updateReview() { // comment aanpassen in store
        this.store.commit('reviewComment', {
          comment: this.submitted.comment,
          question: this.question.id
        });
      },
      setReviewComment(comment) {
        // this.submitted.comment = comment;
        if (comment.length > 0) {
          store.commit('increaseComment')
        } else {
          store.commit('reduceComment')
        }
        this.toggleModal();
        this.updateReview()
      },
      getDraftSub() {
        const draftanswers = store.getters.getDraft;
        if (draftanswers) {
          if (draftanswers[this.question.id]) {
            this.setScore(false, draftanswers[this.question.id])
          }
        }
      },
      setComment(comment) {
        this.answer.comment = comment;
        this.toggleModal();
        this.updateQuestion()
      },
      setScore(e = false, score) {
        //  console.log('setscore', [e, score])
        this.answer.score = score;
        this.updateQuestion();
        if (e) {
          this.clearInvalid(e)
        }
        store.commit('setDraftAnswer', {id: this.question.id, score: score})
      },
      toggleModal() {
        this.modalShown = !this.modalShown
      },
      getQuestionId(name) {
        return name.split(' ').join('-').toLowerCase().substring(0, 20);
      }
    },
    created() {
      // if(this.submitted.comment){
      //   store.commit('increaseComment');
      // }
      if (this.$route.params.draft) {
        this.getDraftSub();
      }

      this.initMenuClick();
      // document.querySelector("body").addEventListener("click", (e)=>{
      //   console.log('click e',e);
      //   const modalEl = this.$el.querySelector('.question-comment');
      //   console.log('modalel',modalEl)
      //   if(e.path.includes(modalEl)){
      //     console.log('clicked modal')
      //   }
      //   // if(e.target !== e.path.includes(modalEl))
      //   this.modalShown = false
      // });
    },
    props: {
      stepind: {
        type: Number,
        default() {
          return 0
        }
      },
      question: {
        type: Object,
        default() {
          return {}
        }
      },
      review: {
        Boolean,
        default() {
          return false
        }
      }
    },
  }
</script>
<style>
  .spacer-50 {
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Vitamins/Question.vue